import { RouterProvider } from "react-router";
import App from "./App";
import Account from "./Pages/Account";
import AccountEdit from "./Pages/Account/Edit";
import AccountEditEmail from "./Pages/Account/EditEmail";
import ContactUs from "./Pages/ContactUs";
import ErrorPage from "./Pages/ErrorPage";
import Faq from "./Pages/Faq";
import Friends from "./Pages/Friends";
import Landing from "./Pages/Landing";
import Login from "./Pages/Login";
import Logout from "./Pages/Logout";
import Notifications from "./Pages/Notifications";
import Privacy from "./Pages/Privacy";
import Registration from "./Pages/Registration";
import RemindPassword from "./Pages/RemindPassword";
import Reserved from "./Pages/Reserved";
import Wish from "./Pages/Wish";
import WishCreate from "./Pages/WishCreate";
import WishEdit from "./Pages/WishEdit";
import Wishlist from "./Pages/Wishlist";
import { RoutePaths } from "./routes";
import Terms from "./Pages/Terms";
import {
  sentryCreateBrowserRouter,
  sentryCreateHashRouter,
} from "../data/sentry";

const routes = [
  {
    path: RoutePaths.root,
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: RoutePaths.root,
        element: <Landing />,
      },
      {
        path: RoutePaths.registration,
        element: <Registration />,
      },
      {
        path: RoutePaths.login,
        element: <Login />,
      },
      {
        path: RoutePaths.remindPassword,
        element: <RemindPassword />,
      },
      {
        path: RoutePaths.specificWishlist,
        element: <Wishlist />,
      },
      {
        path: RoutePaths.myDefaultWishlist,
        element: <Wishlist />,
      },
      {
        path: RoutePaths.wishlistItem,
        element: <Wish />,
      },
      {
        path: RoutePaths.newWish,
        element: <WishCreate />,
      },
      {
        path: RoutePaths.editWish,
        element: <WishEdit />,
      },
      {
        path: RoutePaths.logout,
        element: <Logout />,
      },
      {
        path: RoutePaths.friends,
        element: <Friends />,
      },
      {
        path: RoutePaths.reserved,
        element: <Reserved />,
      },
      {
        path: RoutePaths.account,
        element: <Account />,
      },
      {
        path: RoutePaths.notifications,
        element: <Notifications />,
      },
      {
        path: RoutePaths.contactUs,
        element: <ContactUs />,
      },
      {
        path: RoutePaths.privacyPolicy,
        element: <Privacy />,
      },
      {
        path: RoutePaths.faq,
        element: <Faq />,
      },
      {
        path: RoutePaths.accountEdit,
        element: <AccountEdit />,
      },
      {
        path: RoutePaths.accountEditEmail,
        element: <AccountEditEmail />,
      },
      {
        path: RoutePaths.termsOfUse,
        element: <Terms />,
      },
    ],
  },
];

const router =
  window.location.protocol === "http:" || window.location.protocol === "https:"
    ? sentryCreateBrowserRouter(routes)
    : sentryCreateHashRouter(routes);

export default function Router() {
  return <RouterProvider router={router} />;
}
